export default "__VITE_ASSET__BFZMTHMI__"